// @flow
import type { StoreResourceDef } from 'app/core/types'

export const stepPaths: StoreResourceDef<> = {
  resourceType: 'stepPaths',
  relations: {
    assetInst: {
      type: 'hasOne',
      resourceType: 'assets',
      foreignKey: 'asset',
    },
    stepInst: {
      type: 'hasOne',
      resourceType: 'steps',
      foreignKey: 'step',
    },
  },
}
